import {Palette} from '@customink/ink_colors';
import {isNone} from '~/data/accessors/color';
import Color, {hexToRgb} from '~/data/records/Color';

export const {map: INK_COLORS, list: ORDERED_INK_COLORS} = buildOrderedColors(
  Palette.swatches(),
  color => !isNone(color)
);

export const {
  map: NAMES_AND_NUMBERS_COLORS,
  list: ORDERED_NAMES_AND_NUMBERS_INK_COLORS
} = buildOrderedColors(
  Palette.swatches('personalization'),
  color => !isNone(color)
);

// Do not use custom RGBs here, only ink_colors are valid.
export const PLACEHOLDER_GREY = INK_COLORS.Gray;
export const DARKER_BROWN_FOR_WOODEN_PRODUCT = INK_COLORS['Deep Brown'];
export const LIGHTER_BROWN_FOR_WOODEN_PRODUCT = INK_COLORS.Brown;
export const LUMINANCE_THRESHOLD_BROWN_WOODEN_PRODUCT = 0.3;

export function findColorByRgb(rgb) {
  const color = new Color(rgb);
  const channels = ['red', 'green', 'blue'];
  const matchedColor = ORDERED_INK_COLORS.find(inkColor => {
    return channels.every(channel => inkColor[channel] === color[channel]);
  });
  return matchedColor || INK_COLORS.None;
}

export function findColorByHex(hex) {
  return findColorByRgb(hexToRgb(hex));
}

function buildOrderedColors(swatches, filter) {
  return swatches.reduce(
    (acc, swatch) => {
      const {rgb} = swatch;
      const color = new Color({...swatch, ...rgb});
      if (filter(color)) {
        acc.list.push(color);
      }
      acc.map[color.name] = color;
      return acc;
    },
    {list: [], map: {}}
  );
}
